import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";
import { ENDPOINTS } from "../shared/constants/FormConstants";
import "../plugins/firebase";

let cachedUser: firebase.User | null = null;
let tokenCache: { token: string; exp: number } | null = null;
let authInitialized = false;

// Suscribirse solo una vez al inicio para detectar cambios
function initializeAuthListener() {
  if (authInitialized) return;
  authInitialized = true;

  firebase.auth().onAuthStateChanged(user => {
    cachedUser = user;
    if (!user) tokenCache = null;
  });
}

async function getCachedToken(user: firebase.User): Promise<string> {
  const now = Date.now();
  if (tokenCache && tokenCache.exp > now + 60_000) {
    return tokenCache.token;
  }

  const tokenResult = await user.getIdTokenResult(true);
  const exp = new Date(tokenResult.expirationTime).getTime();
  tokenCache = { token: tokenResult.token, exp };
  localStorage.setItem("TOKEN", tokenResult.token);
  return tokenResult.token;
}

initializeAuthListener();

axios.interceptors.request.use(async request => {
  if (request.url === ENDPOINTS.COUNTRY) return request;

  const user = cachedUser || firebase.auth().currentUser;

  if (user) {
    await getCachedToken(user);
  }

  request.headers = {
    Authorization: localStorage.getItem("TOKEN"),
    "Content-Type": "application/json"
  };

  return request;
});
